import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import { Emphasize, StrikeOut } from "../styles";

const BundleCard = (props) => {
  const {
    bundle,
    raised,
    onClick,
  } = props;

  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      {bundle.tag &&
        <>
          <Box
            style={{
              position: "absolute",
              top: "3px",
              left: "-5px",
              width: 0,
              height: 0,
              borderLeft: "solid 5px transparent",
              borderRight: "solid 5px transparent",
              borderBottom: "solid 5px #980100",
              zIndex: 1,
            }}
          />
          <Box
            style={{
              position: "absolute",
              top: "8px",
              left: "-5px",
              width: "220px",
              height: "24px",
              backgroundColor: "#dc0100",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 3,
              boxShadow: "rgb(220 1 0 / 20%) 0px 2px 4px -1px, rgb(220 1 0 / 14%) 0px 4px 5px 0px, rgb(220 1 0 / 12%) 0px 1px 10px 0px",
              borderTopRightRadius: "5px",
              borderBottomLeftRadius: "5px",
            }}
          >
            <Typography variant="subtitle2">{bundle.tag}</Typography>
          </Box>
          <Box
            style={{
              position: "absolute",
              top: "32px",
              left: "205px",
              width: 0,
              height: 0,
              borderLeft: "solid 5px transparent",
              borderRight: "solid 5px transparent",
              borderTop: "solid 5px #980100",
              zIndex: 1,
            }}
          />
        </>
      }
      <Card
        sx={{ height: "100%" }}
        raised={raised}
        onClick={onClick}
      >
        <CardActionArea
          sx={{
            height: "100%",
            backgroundColor: "#ffffff",
            zIndex: 2,
          }}
        >
          <CardContent
            sx=
              {{
                width: "210px",
                height: "100%",
                paddingTop: "40px",
              }}
            >
            <Typography variant="subtitle2" align="center">{bundle.name}</Typography>
            <Typography variant="subtitle2" align="center">
              {bundle.discounted_price && <StrikeOut>S${bundle.price}</StrikeOut>}
              {bundle.discounted_price && <Emphasize> S${bundle.discounted_price}</Emphasize>}
              {!bundle.discounted_price && <Emphasize>S${bundle.price}</Emphasize>}
            </Typography>
            <ul style={{ textAlign: "left", paddingInlineStart: "24px" }}>
              {bundle.products.slice(0).map((product, index) => (
                <li key={index}><Typography variant="caption">{product.description}</Typography></li>
              ))}
            </ul>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  )
}

export default BundleCard;